/* ════ DRAG CLICK GUARD ════════════════════════════════════ */
// After a drag/draw/resize, the browser fires a trailing click that can land
// on a block (e.g. when you drop over another task) and wrongly open its
// editor. Any gesture calls suppressClick(); block click handlers check
// clickSuppressed() and bail.
let suppressUntil = 0;
export const suppressClick = (ms = 350) => { suppressUntil = Date.now() + ms; };
export const clickSuppressed = () => Date.now() < suppressUntil;
